import { createStorageBase } from '@/core/utils/localStorage';
export const sharedLocalStorage = createStorageBase('local');
